import {HttpEventType, HttpInterceptorFn} from '@angular/common/http';
import {catchError, tap} from "rxjs/operators";
import {inject} from "@angular/core";
import {LoadingSpinnerService} from "../services/loading-spinner.service";
import {throwError} from "rxjs";

export const httpSpinnerInterceptor: HttpInterceptorFn = (req, next) => {
  const loadingSpinner = inject(LoadingSpinnerService)
  loadingSpinner.setLoading(true, req.url);
  return next(req).pipe<unknown>(catchError((err) => {
    loadingSpinner.setLoading(false, req.url)
    throw err;
  }))
    .pipe<any>(tap( (event: any) => {
      if(event.type === HttpEventType.Response){
        loadingSpinner.setLoading(false, req.url)
      }
    }));
};
